<template>
  <div v-outside-click="hideContextMenu" style="position: relative">
    <sub-context :data="data" :depth="0" @hide-subcontext-menu="hideContextMenu" />
  </div>
</template>

<script>
import { Direction, HotkeyScopes, TreeDefaultNodeIds } from "../../../../utils/constants";
import SubContext from "../SubContext.vue";
import { icons } from "../../../../utils/icons";
export default {
  components: { SubContext },
  props: ["item", "teamId"],
  emits: ["hide-sub-contextmenu"],
  data() {
    return {
      index: -1,
      // number of context menu items
      itemsLength: 8,
      data: [
        {
          id: 1,
          icon: `${icons.Plus}`,
          title: this.$t("contextMenu.addPlayer"),
          shortcut: "+",
          func: this.addPlayer,
          hide: this.teamId === TreeDefaultNodeIds.Default || this.item.id === TreeDefaultNodeIds.Default,
          testId: "add-player",
        },
        {
          id: 2,
          icon: `${icons.Edit}`,
          title: this.$t("contextMenu.edit"),
          shortcut: "F2",
          func: this.editPlayer,
          hide: this.teamId === TreeDefaultNodeIds.Default || this.item.level === 1,
          testId: "edit-player",
        },
        {
          id: 3,
          icon: `${icons.Maximize}`,
          title: this.$t("contextMenu.expandCollapse"),
          shortcut: "Space",
          func: this.toggleExpanded,
          testId: "collapse-players",
        },
        {
          id: 4,
          icon: `${icons.Move}`,
          title: this.$t("contextMenu.move"),
          shortcut: `${icons.ChevronRight}`,
          shortcutType: "icon",
          hide: this.teamId === TreeDefaultNodeIds.Default || this.item.level === 1,
          testId: "move-player",
          children: [
            {
              id: 401,
              icon: `${icons.ChevronUp}`,
              title: this.$t("contextMenu.moveUp"),
              shortcut: "Ctrl + &#8593;",
              func: this.moveUp,
              testId: "player-move-up",
            },
            {
              id: 402,
              icon: `${icons.ChevronDown}`,
              title: this.$t("contextMenu.moveDown"),
              shortcut: "Ctrl + &#8595;",
              func: this.moveDown,
              testId: "player-move-down",
            },
            {
              id: 403,
              icon: `${icons.ChevronLeft}`,
              title: this.$t("contextMenu.moveOneLevelUp"),
              shortcut: "Ctrl + &#8592;",
              func: this.moveOneLevelUp,
              testId: "player-move-one-level-up",
            },
            {
              id: 404,
              icon: `${icons.ChevronRight}`,
              title: this.$t("contextMenu.moveOneLevelDown"),
              shortcut: "Ctrl + &#8594;",
              func: this.moveOneLevelDown,
              testId: "player-move-one-level-down",
            },
          ],
        },
        {
          id: 5,
          icon: `${icons.Trash}`,
          title: this.$t("contextMenu.delete"),
          shortcut: "Delete",
          func: this.removePlayer,
          hide: this.teamId === TreeDefaultNodeIds.Default || this.item.level === 1,
          testId: "player-delete",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("setScope", HotkeyScopes.SidebarContextMenu);

    const isTrash = this.item.parents[1] === TreeDefaultNodeIds.Trash;
  },
  methods: {
    addPlayer() {
      this.$store.dispatch("players/addPlayer", { id: this.item.id });
      this.resetHotkeyScope();
    },
    editPlayer() {
      this.$store.dispatch("players/setActiveItem", { id: this.item.id, editMode: true });
      this.resetHotkeyScope();
    },
    removePlayer() {
      this.$store.dispatch("players/remove", { ids: [this.item.id] });
      this.resetHotkeyScope();
    },
    moveUp() {
      this.$store.dispatch("players/moveNode", { id: this.item.id, direction: Direction.Up });
      this.resetHotkeyScope();
    },
    moveDown() {
      this.$store.dispatch("players/moveNode", { id: this.item.id, direction: Direction.Down });
      this.resetHotkeyScope();
    },
    moveOneLevelUp() {
      this.$store.dispatch("players/moveNodeOneLevel", { id: this.item.id, direction: Direction.Up });
      this.resetHotkeyScope();
    },
    moveOneLevelDown() {
      this.$store.dispatch("players/moveNodeOneLevel", { id: this.item.id, direction: Direction.Down });
      this.resetHotkeyScope();
    },
    toggleExpanded() {
      this.$store.dispatch("players/toggleExpanded", { id: this.item.id, itemId: this.item.itemId });
      this.resetHotkeyScope();
    },
    resetHotkeyScope() {
      this.$store.dispatch("setScope", HotkeyScopes.Sidebar.Players);
      this.index = -1;
    },
    hideContextMenu() {
      this.$store.dispatch("resetActiveContextMenu");
      this.resetHotkeyScope();
    },
  },
};
</script>
